import { render } from "./BookingClinic.vue?vue&type=template&id=eb2cd1d2&ts=true"
import script from "./BookingClinic.vue?vue&type=script&lang=ts"
export * from "./BookingClinic.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__